import { useDroppable } from "@dnd-kit/react";
import styled from "styled-components";
import { ProjectsEmptyKanbanCard } from "./ProjectsKanbanCard";


export const ProjectsKanbanColumn = ({id, title, counter, color, children}) => {
    
    const hasValidChildren = Array.isArray(children) && children.some(child => child !== null);
    
    const { ref, isDropTarget } = useDroppable({id});

    return (
        
        <StyledProjectsKanbanColumn ref={ref} $color = {color} className={isDropTarget ? "isDropTarget" : null}>
            <div className="kanbanColumnHeader">
                <span className="headerTitle">
                    {title}
                </span>
                <span className="headerCounter">
                    {counter}
                </span>
            </div>
            <div className="kanbanColumnContent">
                {
                    hasValidChildren ? children : <ProjectsEmptyKanbanCard/>
                }
            </div>
        </StyledProjectsKanbanColumn>
    )
}

const StyledProjectsKanbanColumn = styled.div`
    width: 25%;
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.md};
    transition-duration: 110ms;
    border-radius: ${({theme}) => theme.cornerRadius.md};
    padding-top: ${({theme}) => theme.spacing.sm};

    &.isDropTarget
    {
        background: ${({theme}) => theme.colors.mutedBackground};
    }

    @media (max-width: ${({theme}) => theme.breakPoints.xl})
    {
        flex: 1 1 auto;
    }

    div.kanbanColumnHeader
    {
        display: flex;
        align-items: center;
        gap: ${({theme}) => theme.spacing.md};

        margin-left: ${({theme}) => theme.spacing.md};
        margin-right: ${({theme}) => theme.spacing.md};
        border-bottom: 1px solid ${({theme, $color}) => $color ? $color : theme.colors.neutralSecondaryForeground};
        padding-bottom: ${({theme}) => theme.spacing.sm};
        
        span.headerTitle
        {
            position: relative;
            padding-left: calc(${({theme}) => theme.spacing.md} + ${({theme}) => theme.spacing.sm} + 8px);
            font-weight: 500;
            &::before
            {
                top: 50%;
                left: ${({theme}) => theme.spacing.sm};
                transform: translateY(-50%);
                position: absolute;
                content: "";
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: ${({theme, $color}) => $color ? $color : theme.colors.neutralSecondaryForeground};
            }
        }

        span.headerCounter
        {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: ${({theme}) => theme.spacing.xs};
            padding-bottom: ${({theme}) => theme.spacing.xs};
            padding-left: ${({theme}) => theme.spacing.md};
            padding-right: ${({theme}) => theme.spacing.md};
            border-radius: ${({theme}) => theme.cornerRadius.md};
            color: ${({theme}) => theme.colors.mutedForeground};
            background: ${({theme}) => theme.colors.mutedBackground};
            font-size: ${({theme}) => theme.fontSize.sm};
            border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
        }
    }

    div.kanbanColumnContent
    {
        padding-left: ${({theme}) => theme.spacing.md};
        padding-right: ${({theme}) => theme.spacing.md};
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.md};
        overflow-x: visible;
        overflow-y: auto;
    }
`

